import { PRODUCT_TYPE } from "../../utils/constants";

const normalizePurchaseTypes = (payload) => {
  if (Array.isArray(payload)) return payload;
  const types =
    payload?.data ??
    payload?.selectedPurchaseType ??
    payload?.purchaseTypes ??
    [];
  return Array.isArray(types) ? types : [types];
};

const purchaseTypeLabel = (pt) => {
  if (pt == null) return "";
  if (typeof pt === "string") return pt;
  return pt.label || pt.productType || pt.purchaseType || "";
};

export const hasTeacherSimsPurchase = (payload) =>
  normalizePurchaseTypes(payload).some(
    (pt) => purchaseTypeLabel(pt) === PRODUCT_TYPE.TEACHERSIMS
  );
